import React, { Component, Fragment } from 'react';
import {
  Button,
  Row, Col
} from 'reactstrap';
import Ionicon from 'react-ionicons';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import Sidebar from 'react-sidebar';
import swal from 'sweetalert';
import * as Scroll from 'react-scroll';
// components
import EditOtherBusinessDetail from '../EditOtherBusinessDetail/EditOtherBusinessDetail';
import EditPrimaryContactDetail from '../EditPrimaryContactDetail/EditPrimaryContactDetail';
import EditSocialDetails from '../EditSocialDetails/EditSocialDetails';
import ProfileDetail from '../ProfileDetail/ProfileDetail';
import AddEditSubsidiaries from '../AddEditSubsidiaries/AddEditSubsidiaries';
import ListSubsidiaries from '../ListSubsidiaries/ListSubsidiaries';
import ConfirmModal from '../../modal/ConfirmModal/ConfirmModal';

// service imports
import UserService from '../../services/UserService';
import StorageService from '../../services/Storage';
import Validation from '../../services/Validation';
import { messages } from '../../constants/constant.message';
import FleetService from '../../services/FleetService';

// actions
import { setUserDetail } from '../../actions/UserAction';

// constants
import { config } from '../../constants/constant.config';

// css
import './Registration.css';
import AddEditSubsidiariesService from '../../services/AddEditSubsidiariesService';
import VehicleCountDeatil from '../VehicleCountDeatil/VehicleCountDeatil';
import AddEditFleetVehicle from '../AddEditFleetVehicle/AddEditFleetVehicle';
import VehicleDetail from '../VehicleDetail/VehicleDetail';
import NewFleetCommunicationDetail from '../NewFleetCommunicationDetail/NewFleetCommunicationDetail';
import NewFleetPersonalDetails from '../NewFleetPersonalDetails/NewFleetPersonalDetails';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
import ModalService from '../../services/ModalService';

const { APP_HEADER_LOGO } = config;
class Registration extends Component {
  state = {};

  addEditSubsidiariesArr = [];

  isListSubsidiaries = false;

  dynamicAddEditSubsidiaries() {
    this.stateAddEditSubsidiaries.addEditSubsidiaries.push(
      Object.assign({}, {
        controls: {
          id: '',
          uuid: '',
          pin_code: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'pin_code'
          },
          sap_id: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'sap_id'
          },
          subsidiaryName: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'subsidiaryName'
          },
          address1: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'address_1'
          },
          address2: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'address_2'
          },
          state: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'state_id'
          },
          city: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'city_id'
          },
          gst: {
            value: '',
            valid: true,
            touched: false,
            required: false,
            invalidLength: null,
            showErrorMsg: false,
            databaseFieldName: 'gst_number'
          },
          pan: {
            value: '',
            valid: true,
            required: false,
            touched: false,
            invalidLength: null,
            showErrorMsg: false,
            databaseFieldName: 'pan_number'
          }
        },
        isValidForm: false
      })
    );
  }

  constructor(props) {
    super(props);
    this.stateAddEditSubsidiaries = {
      addEditSubsidiaries: [],
    };
    this.state = {
      isLoading: false,
      editSubsidiariesIndex: 0,
      isAddSubsidiaries: true,
      sidebarOpen: false,
      profileImage: null,
      sapId: null,
      businessName: null,
      ownerName: null,
      address: null,
      isImageUpdating: false,
      isDisplayedSubsidiariesConfirmModal: false,
      isDisplayedFleetConfirmModal: false,
      isFleeData: false,
      isOpenAddEditVehicle: false,
      isAddVehicleDetail: false,
      vehicleData: {},
      controls: {
        company_name: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        company_type: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        owner_name: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        designation: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        mobile_number: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidPhone: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        state: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        city: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        pin_code: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        address: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          invalidLength: null,
          showErrorMsg: false
        },
        email: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        phone: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidPhone: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        gst: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          invalidLength: null,
          showErrorMsg: false
        },
        pan: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        wa: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        primaryPerson: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        primaryEmail: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        primaryDesignation: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        primaryNumber: {
          value: '',
          valid: true,
          invalidPhone: null,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        primaryWa: {
          value: '',
          valid: false,
          touched: false,
          invalidPhone: null,
          required: false,
          showErrorMsg: false,
          autoFocus: false
        },
        birthDate: {
          value: null,
          valid: null,
          touched: false,
          required: true,
          showErrorMsg: false

        },
        anniversaryDate: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        facebook: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        instagram: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        website: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false
        },
        truck: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: true
        },
        bus: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: true
        },
        scv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: true
        },
        lcv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: true
        },
        agreeTermAndCondition: true,
        sameAsUser: false
      },
      isListSubsidiaries: false,
      activeFragment: null,
      isFormValid: false,
      redirectToDashBoard: false,
      showBuildMyFleet: false,
      fleetData: [],
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.childFleetBusinessDetail = React.createRef();
    this.childNewFleetCommunicationDetail = React.createRef();
    this.childNewFleetPersonalDetails = React.createRef();
  }

  componentWillReceiveProps(props) {
  }

  componentDidMount() {
    this.getUserInfo();
    this.getSubsidiaries();
    this.getFleetData();
    this.getBusinessRelatedDetail();
  }

  deleteFleet = async (fleetId, totalTyre, vehicle_type) => {
    try {
      this.setState({ isLoading: true });
      const { data } = await FleetService.deleteFleet({ fleetId, totalTyre });
      if (data.message) {
        ModalService.openAlert(data.message, '', 'success');
        this.getFleetData();
        this.getBusinessRelatedDetail();
      }
      this.setState({ isLoading: false });
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert(e.response.data.error[0].message, '', 'error');
      }
      this.setState({ isLoading: false });
      console.log(e);
    }
  }

  deleteFleetVehicle = (vehicle_type) => {
    swal({
      title: "",
      text: "Are you sure, you want to delete vehicle detail ?",
      icon: "warning",
      buttons: ["No", "Yes"]
    }).then(isConfirm => {
      if (isConfirm) {
        let { fleetData } = this.state;
        let index = fleetData.findIndex(element => element.type.toLowerCase() === vehicle_type);
        if (index > -1) {
          this.deleteFleet(fleetData[index].data[0].fleet_id, fleetData[index].data[0].total_tyre, vehicle_type);
        }
      }
    });
  }

  getSubsidiaries() {
    AddEditSubsidiariesService.getSubsidiaries()
      .then(response => {
        // let isDisplayedSubsidiariesConfirmModal = false;
        if (response.data && response.data.data && response.data.data.length > 0) {
          this.stateAddEditSubsidiaries.addEditSubsidiaries = [];
          response.data.data.forEach(element => {
            this.dynamicAddEditSubsidiaries();
          });
          // this.isListSubsidiaries = true;
          response.data.data.forEach((element, i) => {
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.sap_id.value = element.sap_id;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.address1.value = element.address_1;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.address2.value = element.address_2;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.city.value = element.city_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.gst.value = element.gst_number;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.pan.value = element.pan_number;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.state.value = element.state_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.subsidiaryName.value = element.subsidiary_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.id = element.id;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.uuid = element.uuid;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.pin_code.value = element.pin_code;
          });
          this.setState({ isListSubsidiaries: true, isDisplayedSubsidiariesConfirmModal: true });
          // isDisplayedSubsidiariesConfirmModal = false;
        } else {
          this.stateAddEditSubsidiaries.addEditSubsidiaries = [];
          this.setState({ isListSubsidiaries: false });
          // this.isListSubsidiaries = false;
        }
        // this.setState(prevState => ({
        //   ...prevState
        // }));
      })
      .catch(e => {
        console.error('e', e);
      });
  }

  getUserInfo() {
    UserService.getUserInfo()
      .then(data => {
        const userData = data.data.data;
        this.props.setUserDetail(userData);
        this.setPageValues(userData);
      })
      .catch(e => {
        console.error('e', e);
      });
  }

  setPageValues = (uDetail) => {
    const { email_1, telephone_no_1, gst_number, pan_number, whats_app_number_user, image_url,
      alternate_contact_person, alternate_contact_number, alternate_contact_email,
      birth_date, anniversary_date, facebook_url, instagram_url,
      member_id, business_name, owner_name, address_line_1, address_line_2,
      address_line_3, address_line_4, website: web_from_api,
      truck: truck_from_api, lcv: lcv_from_api, scv: scv_from_api, bus: bus_from_api
    } = uDetail;

    let { controls, sapId, address, businessName, profileImage, ownerName } = this.state;
    const {
      email, phone, gst, pan, wa,
      primaryPerson, primaryNumber, primaryDesignation, primaryEmail, primaryWa,
      birthDate, anniversaryDate, facebook, instagram, website,
      truck, bus, scv, lcv
    } = controls;

    controls.owner_name.value = uDetail.owner_name;
    controls.company_name.value = uDetail.company_name;
    controls.company_type.value = uDetail.company_type;
    controls.designation.value = uDetail.designation;
    controls.mobile_number.value = uDetail.mobile_number;
    controls.address.value = uDetail.address;

    controls.state.value = uDetail.state;
    // if (controls.state.value) {
    //   this.childFleetBusinessDetail.current.getCity(controls.state.value);
    // }
    if (this.childNewFleetCommunicationDetail.current) {
      this.childNewFleetCommunicationDetail.current.setFleetDetail(uDetail);
    }
    if (this.childNewFleetPersonalDetails.current) {
      if (uDetail.child_1_date_of_birth) {
        uDetail.child_1_dob = uDetail.child_1_date_of_birth;
      }
      if (uDetail.child_2_date_of_birth) {
        uDetail.child_2_dob = uDetail.child_2_date_of_birth;
      }
      if (uDetail.spouse_date_of_birth) {
        uDetail.spouse_dob = uDetail.spouse_date_of_birth;
      }
      if (uDetail.educational_qualification) {
        uDetail.education_qualification = uDetail.educational_qualification;
      }
      this.childNewFleetPersonalDetails.current.setFleetDetail(uDetail);
    }
    controls.city.value = uDetail.city;
    controls.pin_code.value = uDetail.pin_code;
    profileImage = image_url;
    email.value = email_1;
    phone.value = telephone_no_1;
    // phone.value = null;
    gst.value = gst_number;
    pan.value = pan_number;
    wa.value = whats_app_number_user;

    primaryPerson.value = alternate_contact_person;
    primaryNumber.value = alternate_contact_number;
    primaryDesignation.value = uDetail.alternate_designation;
    primaryWa.value = uDetail.whats_app_number;
    primaryEmail.value = alternate_contact_email;

    website.value = web_from_api;

    // birthDate.value = null;
    // anniversaryDate.value = null;

    birthDate.value = birth_date ? new Date(birth_date) : null;
    anniversaryDate.value = anniversary_date ? new Date(anniversary_date) : null;
    facebook.value = facebook_url;
    instagram.value = instagram_url;

    truck.value = truck_from_api;
    bus.value = bus_from_api;
    scv.value = scv_from_api;
    lcv.value = lcv_from_api;

    sapId = member_id;
    businessName = business_name;
    ownerName = owner_name;
    address = `${address_line_1 ? address_line_1 : ''}${address_line_2 ? ', ' + address_line_2 : ''}${address_line_3 ? ', ' + address_line_3 : ''}${address_line_4 ? ', ' + address_line_4 : ''}`;

    // if (email.value === null || email.value === "") {
    //   email.autoFocus = true;
    // } else if (phone.value === null || phone.value === "") {
    //   phone.autoFocus = true;
    // } else if (wa.value === null || wa.value === "") {
    //   wa.autoFocus = true;
    // }
    this.setState({ controls, sapId, businessName, address, profileImage, ownerName }, () => {
      if (this.childFleetBusinessDetail.current) {
        this.childFleetBusinessDetail.current.getState();
      }
    });
    this.handleValidation(true);
  }

  handleUploadImage = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const obj = {
      file
    };
    this.setState({ isImageUpdating: true });
    UserService.uploadImage(obj)
      .then(data => {
        this.setState({
          profileImage: URL.createObjectURL(file),
          isImageUpdating: false
        });
      })
      .catch(e => {
        this.setState({
          profileImage: null,
          isImageUpdating: false
        });
      });
  }

  goToPreviousPage = () => {
    this.props.handleGoToNextPage('ob2');
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;

    if (controlName === 'state') {
      controls.state.value = controlValue;
      controls.city.value = '';
    } else if (controlName === 'company_type') {
      if (e.target.value === 'proprietor') {
        controls.designation.value = 'owner';
      } else if (e.target.value === 'partnership') {
        controls.designation.value = 'partner';
      } else if (e.target.value === 'private limited') {
        controls.designation.value = 'director';
      } else if (e.target.value === 'limited') {
        controls.designation.value = 'director';
      }
      controls.company_type.value = controlValue;
      controls.designation.touched = true;
      controls.designation.showErrorMsg = false;
      //this.props.345(controls.designation.value);
    } else if (controlName === 'phone' || controlName === 'pin_code' ||
      controlName === 'mobile_number' || controlName === 'wa' || controlName === 'primaryNumber' ||
      controlName === 'primaryWa') {
      if (!isNaN(controlValue)) {
        controls[controlName].value = controlValue;
      }
    } else {
      controls[controlName].value = controlValue;
    }
    //controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls }, () => {
      if (controlName === 'state') {
        this.childFleetBusinessDetail.current.getCity(controlValue);
      }
    });
    this.handleValidation();
  }

  handleBirthDateChange = (e) => {
    const { controls } = this.state;
    const { birthDate } = controls;
    birthDate.value = e;
    birthDate.touched = true;
    this.setState({ controls });
    this.handleValidation();
  }

  handleAnniversaryDateChange = (e) => {
    const { controls } = this.state;
    const { anniversaryDate } = controls;
    anniversaryDate.value = e;
    anniversaryDate.touched = true;
    this.setState({ controls });
    this.handleValidation();
  }

  setCheckBoxValue = () => {
    const { controls } = this.state;
    // const { agreeTermAndCondition } = controls;
    controls.agreeTermAndCondition = !controls.agreeTermAndCondition;
    // agreeTermAndCondition.value = !agreeTermAndCondition.value;
    this.setState({ controls });
    this.handleValidation();
  }

  setSameAsUserCheckBoxValue = () => {
    const { controls } = this.state;
    const { primaryPerson, primaryNumber, primaryDesignation, primaryEmail, primaryWa, email, wa } = controls;
    // const { agreeTermAndCondition } = controls;
    controls.sameAsUser = !controls.sameAsUser;
    if (controls.sameAsUser === true) {
      primaryPerson.value = controls.owner_name.value;
      primaryPerson.touched = true;

      primaryNumber.value = controls.mobile_number.value;
      primaryNumber.touched = true;

      primaryDesignation.value = controls.designation.value;
      primaryDesignation.touched = true;

      primaryEmail.value = email.value;
      primaryEmail.touched = true;

      primaryWa.value = wa.value;
      primaryWa.touched = true;
    } else {
      primaryPerson.value = '';
      primaryPerson.touched = true;

      primaryNumber.value = '';
      primaryNumber.touched = true;

      primaryDesignation.value = '';
      primaryDesignation.touched = true;

      primaryEmail.value = '';
      primaryEmail.touched = true;

      primaryWa.value = '';
      primaryWa.touched = true;
    }
    // else {
    //   alPerson.value = ;
    //   alNumber.value = phone.value;
    // }
    // agreeTermAndCondition.value = !agreeTermAndCondition.value;
    this.setState({ controls });
    // setTimeout(() => {
    //   this.handleValidation();
    // }, 1000);
    this.handleValidation();
  }

  activeFragment = (fragment) => {
    this.setState({ activeFragment: fragment });
  }
  proceedToUpdateBusinessRelatedDetail = async (obj) => {

    try {
      this.setState({
        isLoading: true
      })
      const { data } = await FleetService.updateBusinessRelatedDetails(obj);

      this.setState({
        isLoading: false
      })
      if (data.success) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      this.setState({
        isLoading: false
      })
      return e.response.data.error[0].message;
    }
  }

  updateBusinessRelatedDetails = async () => {
    if (this.refs.refVehicleDetail && this.refs.refVehicleDetail.state) {
      let frontRearData = this.refs.refVehicleDetail.state.frontRearData;
      let bias_radial_tyres = this.refs.refVehicleDetail.state.controls.bias_radial_tyres;
      let resFrontData = {
        bus: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          bias_radial_count: {},
          business_related_detail: []
        },
        truck: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          bias_radial_count: {},
          business_related_detail: []
        },
        lcv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        scv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        icv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        pickup: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        }
      };
      if (frontRearData && Object.keys(frontRearData).length > 0) {
        Object.keys(frontRearData).forEach((key, i) => {
          frontRearData[key].forEach(element => {
            if (element.fleet_id) {
              resFrontData[key].fleet_id = element.fleet_id;
            }
            if (element.temp_id) {
              resFrontData[key].temp_id = element.temp_id;
            }
            if (element.vehicle_type_id) {
              resFrontData[key].vehicle_type_id = element.vehicle_type_id;
            }
            if (element.vehicle_type.value) {
              resFrontData[key].vehicle_type = element.vehicle_type.value;
            }
            let brand = element.brand.value;
            if (element.brand.value && element.brand.value.toLowerCase() === 'jk tyre') {
              brand = "JK Tyre";
            } else if (element.brand.value && element.brand.value.toLowerCase() === 'vikrant') {
              brand = "Vikrant";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'apollo') {
              brand = "Apollo";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'mrf') {
              brand = "Mrf";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'ceat') {
              brand = "Ceat";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'contil') {
              brand = "Contil";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'birla') {
              brand = "Birla";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'bkt') {
              brand = "Bkt";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'bridgestone') {
              brand = "Bridgestone";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'chalanger') {
              brand = "Chalanger";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'michelin') {
              brand = "Michelin";
            }
            resFrontData[key].business_related_detail.push({
              construction: element.construction.value,
              size: element.size.value,
              brand: brand,
              pattren: element.pattren.value,
              tyres: element.tyres.value ? parseInt(element.tyres.value) : 0,
              brand_id: element.brand_id.value ? element.brand_id.value : '',
              type: element.type.value ? element.type.value : ''
            })
          });
        });
      }
      let invalidCountError = {
        truck: {
          message: '',
          isInValid: false
        },
        bus: {
          message: '',
          isInValid: false
        },
        lcv: {
          message: '',
          isInValid: false
        },
        scv: {
          message: '',
          isInValid: false
        },
        icv: {
          message: '',
          isInValid: false
        },
        pickup: {
          message: '',
          isInValid: false
        }
      };
      if (resFrontData.truck.business_related_detail.length > 0) {
        resFrontData.truck.bias_radial_count = bias_radial_tyres.truck;
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.truck);
        if (resBusinessRelated !== true) {
          invalidCountError.truck.isInValid = true;
          invalidCountError.truck.message = resBusinessRelated;
        }
      }
      if (resFrontData.bus.business_related_detail.length > 0) {
        resFrontData.bus.bias_radial_count = bias_radial_tyres.bus;
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.bus);
        if (resBusinessRelated !== true) {
          invalidCountError.bus.isInValid = true;
          invalidCountError.bus.message = resBusinessRelated;
        }
      }
      if (resFrontData.scv.business_related_detail.length > 0) {
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.scv);
        if (resBusinessRelated !== true) {
          invalidCountError.scv.isInValid = true;
          invalidCountError.scv.message = resBusinessRelated;
        }
      }
      if (resFrontData.icv.business_related_detail.length > 0) {
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.icv);
        if (resBusinessRelated !== true) {
          invalidCountError.icv.isInValid = true;
          invalidCountError.icv.message = resBusinessRelated;
        }
      }
      if (resFrontData.pickup.business_related_detail.length > 0) {
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.pickup);
        if (resBusinessRelated !== true) {
          invalidCountError.pickup.isInValid = true;
          invalidCountError.pickup.message = resBusinessRelated;
        }
      }
      if (resFrontData.lcv.business_related_detail.length > 0) {
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.lcv);
        if (resBusinessRelated !== true) {
          invalidCountError.lcv.isInValid = true;
          invalidCountError.lcv.message = resBusinessRelated;
        }
      }
      this.inValidCountVehicleDetailError(invalidCountError);
      return invalidCountError;
    }
  }

  inValidCountVehicleDetailError = (obj) => {
    if (this.refs.refVehicleDetail) {
      this.refs.refVehicleDetail.inValidCountVehicleDetailError(obj);
    }
  }

  toCamelCase = (str) => {
    if (str) {
      str = str ? str.toString() : '';
      str = str.split(" ");

      for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1);
      }

      return str.join(" ");
    }
    return str;
  }

  checkAllValidation() {
    let form1 = true; let form2 = true; let form3 = true, form4 = true, form5 = true;
    let { location } = this.props;
    if (!this.handleValidation(false, true)) {
      form1 = false;
    }

    if (!this.childNewFleetPersonalDetails.current.handleValidation(true)) {
      form2 = false;
    }

    if (!this.childNewFleetCommunicationDetail.current.handleValidation(true)) {
      form3 = false;
    }

    if (!this.refs.refCountVehicleDetail.handleValition()) {
      form4 = false;
    }

    if (location && location.pathname !== "/on-boarding") {
      if (!this.refs.refVehicleDetail.checkAllDataValidationFront()) {
        form5 = false;
      }
    }

    if (form1 === false) {
      this.scrollTo('form-business-detail');
    } else if (form2 === false) {
      this.scrollTo('form-personal-detail');
    } else if (form3 === false) {
      this.scrollTo('form-communcation-detail');
    } else if (form4 === false) {
      this.scrollTo('form-vehicle-count-detail');
    } else if (form5 === false) {
      this.scrollTo('form-vehcicle-detail');
    }

    return !!(form1 === true && form2 === true && form3 === true && form4 === true &&
      form5 === true);
  }
  updateBaadshsaCategory = async () => {
    try {
      const { data } = await FleetService.updateBaadshsaCategory();
      if (data.success) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
    }
  }
  updateProfile = async () => {
    let { location } = this.props;
    const isFormValid = this.checkAllValidation();
    if (isFormValid === false) {
      return;
    }
    // if (!this.state.isDisplayedFleetConfirmModal) {
    //   this.toggleModal({ title: 'Build Your Fleet', message: 'WOW! You can provide your fleet information and earn 500 points now.', backdrop: true });
    //   return;
    // }
    let invalidCountError = await this.updateBusinessRelatedDetails();
    if (location && location.pathname !== "/on-boarding") {
      if (invalidCountError.truck.isInValid || invalidCountError.bus.isInValid || invalidCountError.lcv.isInValid ||
        invalidCountError.scv.isInValid || invalidCountError.icv.isInValid || invalidCountError.pickup.isInValid) {
        return
      }
    }

    // if (!this.state.isDisplayedSubsidiariesConfirmModal) {
    //   this.toggleModal({ title: 'Add Subsidiaries', message: 'You haven’t added any subsidiaries yet. Would you like to add now?', backdrop: true });
    //   return;
    // }
    const { controls } = this.state;
    const {
      email,
      phone,
      gst,
      pan,
      wa,
      primaryPerson,
      primaryNumber,
      primaryDesignation,
      primaryWa,
      primaryEmail,
      facebook,
      instagram,
      website,
      agreeTermAndCondition
    } = controls;
    // alternate_designation, mobile_number, email, address, state, city, pin_code,
    //   communication_address, communication_state, communication_city, communication_pin_code

    let controlsNewFleetPersonalDetails = this.childNewFleetPersonalDetails.current.state.controls;
    let controlsNewFleetCommunicationDetail = this.childNewFleetCommunicationDetail.current.state.controls;
    const obj = {
      company_name: controls.company_name.value,
      company_type: controls.company_type.value,
      owner_name: controls.owner_name.value,
      mobile_number: controls.mobile_number.value,
      // email: controls.email.value,
      address: controls.address.value,
      state: controls.state.value ? this.toCamelCase(controls.state.value) : '',
      city: controls.city.value ? this.toCamelCase(controls.city.value) : '',
      pin_code: controls.pin_code.value,
      "communication_address": controlsNewFleetCommunicationDetail.communication_address.value,
      "communication_state": controlsNewFleetCommunicationDetail.communication_state.value,
      "communication_city": controlsNewFleetCommunicationDetail.communication_city.value,
      "communication_pin_code": controlsNewFleetCommunicationDetail.communication_pin_code.value,
      "home_address": controlsNewFleetPersonalDetails.home_address.value,
      "birthDate": controlsNewFleetPersonalDetails.birth_date.value,
      "educational_qualification": controlsNewFleetPersonalDetails.education_qualification.value,
      "languages": [],
      "marital_status": controlsNewFleetPersonalDetails.marital_status.value,
      "anniversary_date": controlsNewFleetPersonalDetails.marital_status.value === 'married' ? controlsNewFleetPersonalDetails.anniversary_date.value : null,
      "spouse_name": controlsNewFleetPersonalDetails.marital_status.value === 'married' ? controlsNewFleetPersonalDetails.spouse_name.value : '',
      "spouse_date_of_birth": controlsNewFleetPersonalDetails.marital_status.value === 'married' ? controlsNewFleetPersonalDetails.spouse_dob.value : null,
      "child_1_name": controlsNewFleetPersonalDetails.marital_status.value === 'married' && controlsNewFleetPersonalDetails.isAddChild.value ? controlsNewFleetPersonalDetails.child_1_name.value : null,
      "child_1_date_of_birth": controlsNewFleetPersonalDetails.marital_status.value === 'married' && controlsNewFleetPersonalDetails.isAddChild.value ? controlsNewFleetPersonalDetails.child_1_dob.value : null,
      "child_2_name": controlsNewFleetPersonalDetails.marital_status.value === 'married' && controlsNewFleetPersonalDetails.isAddChild.value ? controlsNewFleetPersonalDetails.child_2_name.value : null,
      "child_2_date_of_birth": controlsNewFleetPersonalDetails.marital_status.value === 'married' && controlsNewFleetPersonalDetails.isAddChild.value ? controlsNewFleetPersonalDetails.child_2_dob.value : null,
      'designation': controls.designation.value,
      'email': email.value,
      'phoneNumber': phone.value, // only numbers
      'gstNumber': gst.value ? gst.value.toUpperCase() : null, // 15 digit
      'panNumber': pan.value ? pan.value.toUpperCase() : null, // 10 digit
      'countryCode': '+91',
      'whatsappNumberUser': wa.value,

      'alternateContactPerson': primaryPerson.value,
      'alternateContactNumber': primaryNumber.value,
      'alternateContactEmail': primaryEmail.value,
      'alternateContactNumberCountryCode': '+91',
      'alternate_designation': primaryDesignation.value,
      'whatsappNumber': primaryWa.value,
      'whatsappNumberCountryCode': '+91',
      'facebookUrl': facebook.value,
      'instagramUrl': instagram.value,
      'website': website.value,

      // 'bus': bus.value,
      // 'truck': truck.value,
      // 'lcv': lcv.value,
      // 'scv': scv.value,

      'isTermsAccepted': agreeTermAndCondition,

      'isLoginFirstTime': false,
    };
    if (controlsNewFleetPersonalDetails.languages.value && controlsNewFleetPersonalDetails.languages.value.length > 0) {
      controlsNewFleetPersonalDetails.languages.value.forEach(element => {
        obj.languages.push(element.label);
      });
    }

    UserService.updateUserInfo(obj)
      .then(data => {
        const userDetail = StorageService.getUserDetail();
        userDetail.is_login_first_time = false;
        const userData = data.data.data;
        this.props.setUserDetail(userData);
        StorageService.setUserDetail(userDetail);
        swal('', 'You’ve successfully registered your fleet.', 'success').then((value) => {
          this.setState({ redirectToDashBoard: true });
        });

      })
      .catch(e => {
        console.log('err', e);
      });

  }

  /**
   * @param firstTime when form loads for first time directly error showing makes bad experience
   *            so do not show any message for null values but disable save button if 
   *            there is something missing or some error.
   */
  handleValidation = (firstTime, isSubmit = false) => {
    // let firstTime = true;


    let { controls, isFormValid } = this.state;
    let {
      email, phone, gst, pan, wa,
      primaryPerson, primaryNumber, primaryEmail, primaryDesignation, primaryWa,
      birthDate, website, instagram, facebook, anniversaryDate, agreeTermAndCondition,
      company_name, company_type, state, city, pin_code, address,
      owner_name, mobile_number
    } = controls;

    if (firstTime === true || email.touched === true || isSubmit) {
      email = Validation.notNullValidator(email);
      email = Validation.emailValidator(email);
      email.valid = !(email.nullValue || email.invalidEmail);
      if ((firstTime && email.invalidEmail) || ((email.touched || isSubmit) && email.valid === false)) {
        email.showErrorMsg = true;
      } else {
        email.showErrorMsg = false;
      }
    }


    if (firstTime === true || phone.touched === true || isSubmit) {
      phone = Validation.notNullValidator(phone);
      phone = Validation.validatePhoneNumber(phone);
      phone.valid = !(phone.nullValue || phone.invalidPhone);
      if ((firstTime && phone.invalidPhone) || ((phone.touched || isSubmit) && phone.valid === false)) {
        phone.showErrorMsg = true;
      } else {
        phone.showErrorMsg = false;
      }
    }
    gst.valid = true;
    pan.valid = true;
    // if (firstTime === true || gst.touched === true || isSubmit) {
    //   gst = Validation.validateLength(gst, 15);
    //   gst.valid = !(gst.invalidLength);
    //   if ((firstTime && gst.invalidLength) || ((gst.touched || isSubmit) && gst.valid === false)) {
    //     gst.showErrorMsg = true;
    //   } else {
    //     gst.showErrorMsg = false;
    //   }
    // }

    // if (firstTime === true || pan.touched === true || isSubmit) {
    //   pan = Validation.validateLength(pan, 10);
    //   pan.valid = !(pan.invalidLength);
    //   if ((firstTime && pan.invalidLength) || ((pan.touched || isSubmit) && pan.valid === false)) {
    //     pan.showErrorMsg = true;
    //   } else {
    //     pan.showErrorMsg = false;
    //   }
    // }

    if (firstTime === true || wa.touched === true || isSubmit) {
      wa = Validation.notNullValidator(wa);
      wa = Validation.validatePhoneNumber(wa);
      wa.valid = !(wa.invalidPhone || wa.nullValue);
      if ((firstTime && wa.invalidPhone) || ((wa.touched || isSubmit) && wa.valid === false)) {
        wa.showErrorMsg = true;
      } else {
        wa.showErrorMsg = false;
      }
    }


    if (firstTime === true || primaryPerson.touched === true || isSubmit) {
      primaryPerson = Validation.notNullValidator(primaryPerson);
      primaryPerson.valid = !(primaryPerson.nullValue); // it will be removed
      if (((primaryPerson.touched || isSubmit) && primaryPerson.valid === false)) {
        primaryPerson.showErrorMsg = true;
      } else {
        primaryPerson.showErrorMsg = false;
      }
    }

    // if (firstTime === true || primaryPerson.touched === true || isSubmit) {
    //   primaryPerson.valid = !(primaryPerson.nullValue); // it will be removed
    // }

    if (firstTime === true || primaryNumber.touched === true || isSubmit) {
      primaryNumber = Validation.validatePhoneNumber(primaryNumber);
      primaryNumber = Validation.notNullValidator(primaryNumber);
      primaryNumber.valid = !(primaryNumber.invalidPhone || primaryNumber.nullValue);
      if ((firstTime && primaryNumber.invalidPhone) || ((primaryNumber.touched || isSubmit) && primaryNumber.valid === false)) {
        primaryNumber.showErrorMsg = true;
      } else {
        primaryNumber.showErrorMsg = false;
      }
    }
    if (firstTime === true || primaryEmail.touched === true || isSubmit) {
      primaryEmail = Validation.notNullValidator(primaryEmail);
      primaryEmail = Validation.emailValidator(primaryEmail);
      primaryEmail.valid = !(primaryEmail.nullValue || primaryEmail.invalidEmail);
      if ((firstTime && primaryEmail.invalidEmail) || ((primaryEmail.touched || isSubmit) && primaryEmail.valid === false)) {
        primaryEmail.showErrorMsg = true;
      } else {
        primaryEmail.showErrorMsg = false;
      }
    }

    if (firstTime === true || primaryDesignation.touched === true || isSubmit) {
      primaryDesignation = Validation.notNullValidator(primaryDesignation);

      primaryDesignation.valid = !(primaryDesignation.nullValue);
      if (((primaryDesignation.touched || isSubmit) && primaryDesignation.valid === false)) {
        primaryDesignation.showErrorMsg = true;
      } else {
        primaryDesignation.showErrorMsg = false;
      }
    }

    if (firstTime === true || primaryWa.touched === true || isSubmit) {
      primaryWa = Validation.notNullValidator(primaryWa);
      primaryWa = Validation.validatePhoneNumber(primaryWa);
      primaryWa.valid = !(primaryWa.invalidPhone || primaryWa.nullValue);
      if ((firstTime && primaryWa.invalidPhone) || ((primaryWa.touched || isSubmit) && primaryWa.valid === false)) {
        primaryWa.showErrorMsg = true;
      } else {
        primaryWa.showErrorMsg = false;
      }
    }

    if (firstTime === true || birthDate.touched === true || isSubmit) {
      if (birthDate.value === null || birthDate.value === undefined || birthDate.value === '') {
        birthDate.nullValue = true;
      } else {
        birthDate.nullValue = false;
      }
      birthDate.valid = !(birthDate.nullValue);
      if (((birthDate.touched || isSubmit) && birthDate.valid === false)) {
        birthDate.showErrorMsg = true;
      } else {
        birthDate.showErrorMsg = false;
      }
    }



    if (firstTime === true || anniversaryDate.touched === true || isSubmit) {
      anniversaryDate.valid = !(anniversaryDate.nullValue);
    }

    if (firstTime === true || facebook.touched === true || isSubmit) {
      facebook.valid = !(facebook.nullValue);
    }

    if (firstTime === true || instagram.touched === true || isSubmit) {
      instagram.valid = !(instagram.nullValue);
    }

    if (firstTime === true || website.touched === true || isSubmit) {
      // website = Validation.notNullValidator(website);
      website.valid = !(website.nullValue);
      if (((website.touched || isSubmit) && website.valid === false)) {
        website.showErrorMsg = true;
      } else {
        website.showErrorMsg = false;
      }
    }

    if (firstTime === true || company_name.touched === true || isSubmit) {
      if (company_name.value === null || company_name.value === undefined || company_name.value === '') {
        company_name.nullValue = true;
      } else {
        company_name.nullValue = false;
      }
      company_name.valid = !(company_name.nullValue);
      if (((company_name.touched || isSubmit) && company_name.valid === false)) {
        company_name.showErrorMsg = true;
      } else {
        company_name.showErrorMsg = false;
      }
    }

    if (firstTime === true || owner_name.touched === true || isSubmit) {
      if (owner_name.value === null || owner_name.value === undefined || owner_name.value === '') {
        owner_name.nullValue = true;
      } else {
        owner_name.nullValue = false;
      }
      owner_name.valid = !(owner_name.nullValue);
      if (((owner_name.touched || isSubmit) && owner_name.valid === false)) {
        owner_name.showErrorMsg = true;
      } else {
        owner_name.showErrorMsg = false;
      }
    }


    if (firstTime === true || company_type.touched === true || isSubmit) {
      if (company_type.value === null || company_type.value === undefined || company_type.value === '') {
        company_type.nullValue = true;
      } else {
        company_type.nullValue = false;
      }
      company_type.valid = !(company_type.nullValue);
      if (((company_type.touched || isSubmit) && company_type.valid === false)) {
        company_type.showErrorMsg = true;
      } else {
        company_type.showErrorMsg = false;
      }
    }

    if (firstTime === true || address.touched === true || isSubmit) {
      if (address.value === null || address.value === undefined || address.value === '') {
        address.nullValue = true;
      } else {
        address.nullValue = false;
      }
      address.valid = !(address.nullValue);
      if (((address.touched || isSubmit) && address.valid === false)) {
        address.showErrorMsg = true;
      } else {
        address.showErrorMsg = false;
      }
    }


    if (firstTime === true || state.touched === true || isSubmit) {

      if (state.value === null || state.value === undefined || state.value === '') {
        state.nullValue = true;
      } else {
        state.nullValue = false;
      }
      state.valid = !(state.nullValue);
      if (((state.touched || isSubmit) && state.valid === false)) {
        state.showErrorMsg = true;
      } else {
        state.showErrorMsg = false;
      }
    }

    if (firstTime === true || city.touched === true || isSubmit) {
      if (city.value === null || city.value === undefined || city.value === '') {
        city.nullValue = true;
      } else {
        city.nullValue = false;
      }
      city.valid = !(city.nullValue);
      if (((city.touched || isSubmit) && city.valid === false)) {
        city.showErrorMsg = true;
      } else {
        city.showErrorMsg = false;
      }
    }


    if (firstTime === true || pin_code.touched === true || isSubmit) {
      if (pin_code.value === null || pin_code.value === undefined || pin_code.value === '') {
        pin_code.nullValue = true;
      } else {
        pin_code.nullValue = false;
      }
      pin_code.valid = !(pin_code.nullValue);
      if (((pin_code.touched || isSubmit) && pin_code.valid === false)) {
        pin_code.showErrorMsg = true;
      } else {
        pin_code.showErrorMsg = false;
      }
    }


    if ((mobile_number.touched === true) || isSubmit) {
      mobile_number = Validation.notNullValidator(mobile_number);
      mobile_number = Validation.validatePhoneNumber(mobile_number);
      mobile_number = Validation.validateLength(mobile_number, 10);
      mobile_number.valid = !(mobile_number.invalidPhone || mobile_number.nullValue || mobile_number.invalidLength);
      if (mobile_number.valid === false) {
        mobile_number.showErrorMsg = true;
      } else {
        mobile_number.showErrorMsg = false;
      }
    }


    if (
      email.valid === true &&
      phone.valid === true &&
      wa.valid === true &&
      primaryPerson.valid === true &&
      primaryNumber.valid === true &&
      mobile_number.valid === true &&
      primaryDesignation.valid === true &&
      primaryEmail.valid === true &&
      primaryWa.valid === true &&
      facebook.valid === true &&
      instagram.valid === true &&
      website.valid === true &&
      agreeTermAndCondition === true &&
      company_name.valid === true &&
      company_type.valid === true &&
      owner_name.valid === true &&
      address.valid === true &&
      state.valid === true &&
      city.valid === true &&
      pin_code.valid === true
    ) {
      isFormValid = true;
    } else {
      isFormValid = false;
    }

    this.setState({ controls, isFormValid });
    return isFormValid;
  }

  closeConfirmSubsidiryAndFleet = (data) => {
    if (data.title === 'Add Subsidiaries') {
      if (data.flag) {
        this.onSetSidebarOpen(true);
      } else {
        this.setState(prevState => ({
          ...prevState,
          isDisplayedSubsidiariesConfirmModal: true
        }));
      }
    }
    if (data.title === 'Build Your Fleet') {
      this.setState(prevState => ({
        ...prevState,
        isDisplayedFleetConfirmModal: true
      }));
      if (data.flag) {
        this.buildMyFleetClick(true);
      }
    }
    if (!data.flag) {
      setTimeout(() => {
        this.updateProfile();
      }, 500);
    }
  }

  onCloseSidebar = () => {
    document.body.style.overflow = 'auto';
    this.getSubsidiaries();
    this.setState((prevState) => {
      return { ...prevState, sidebarOpen: false };
    });
  }

  onSetSidebarOpen(open) {
    document.body.style.overflow = 'hidden';
    this.dynamicAddEditSubsidiaries();
    this.setState((prevState) => {
      return { ...prevState, isDisplayedSubsidiariesConfirmModal: true, sidebarOpen: open, isAddSubsidiaries: true, editSubsidiariesIndex: this.stateAddEditSubsidiaries.addEditSubsidiaries.length - 1 };
    });

    setTimeout(() => {
      if (Object.keys(this.refs).length > 0 && this.refs && this.refs.childAddEditSubsidiaries) {
        this.refs.childAddEditSubsidiaries.setValue();
      }
    }, 1);
  }

  addSubsidiaries = () => {
    this.getSubsidiaries();
    this.onCloseSidebar();
  }

  editSubsidiaries = (index) => {
    this.setState((prevState) => {
      return { ...prevState, sidebarOpen: true, editSubsidiariesIndex: index, isAddSubsidiaries: false };
    });
    setTimeout(() => {
      if (Object.keys(this.refs).length > 0 && this.refs && this.refs.childAddEditSubsidiaries) {
        this.refs.childAddEditSubsidiaries.setEditData(index);
      }
    }, 1);
  }

  removeSubsidiaries = (id) => {
    AddEditSubsidiariesService.deleteSubsidiaries({ id })
      .then(response => {
        document.body.style.overflow = 'auto';
        swal('Deleted Subsidiary', messages.ADD_EDIT_SUBSIDIARIES.SUCCESS_DELETED_SUBSIDIARIES, 'success');
        this.getSubsidiaries();
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          swal('', e.response.data.error[0].message, 'error');
        }
      });
  }

  makeEditActiveFleet = (controlName, value) => {
    const { controls } = this.state;
    controls[controlName].isEditActive = value;
    this.setState({ controls });
  }

  toggleModal = (modal) => {
    this.refs.confirmModal.toggle(modal);
  }

  buildMyFleetClick = (flag) => {
    this.setState({ showBuildMyFleet: flag, isDisplayedFleetConfirmModal: true });
    if (!flag) {
      this.getFleetData();
    }
  }

  async getFleetData() {
    let { fleetData } = this.state;
    try {
      this.setState({
        isLoading: true
      })
      const { data } = await FleetService.getFleetData();
      if (data) {
        fleetData = data.data;
        this.setState({ fleetData: data.data });
        // let businessRelatedDetail = {
        //   truck: [],
        //   bus: [],
        //   lcv: [],
        //   scv: [],
        //   icv: [],
        //   pickup: []
        // };

        let totalCountBus = 0, totalCountTruck = 0, totalCountLcv = 0,
          totalCountScv = 0, totalCountIcv = 0, totalCountPickup = 0, totalCountRetread = false,
          totalWheelTruck = 0,
          totalWheelBus = 0,
          totalWheelSCV = 0,
          totalWheelLCV = 0,
          totalWheelICV = 0,
          totalWheelPickup = 0;
        data.data.forEach(element => {
          let count = 0;
          if (element.type.toLowerCase() === 'retread') {
            count = element.data[0].number_of_tyres_vehicle_count.tyres_per_month;
          }
          if (element.type.toLowerCase() === 'truck') {
            totalCountTruck = element.total_vehical;
            totalWheelTruck = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'bus') {
            totalCountBus = element.total_vehical;
            totalWheelBus = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'scv') {
            totalCountScv = element.total_vehical;
            totalWheelSCV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'lcv') {
            totalCountLcv = element.total_vehical;
            totalWheelLCV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'icv') {
            totalCountIcv = element.total_vehical;
            totalWheelICV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'pickup') {
            totalCountPickup = element.total_vehical;
            totalWheelPickup = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'retread') {
            totalCountRetread = true;
          }
        });
        this.refs.refCountVehicleDetail.setData({
          totalCountBus: totalCountBus,
          totalCountTruck: totalCountTruck,
          totalCountLcv: totalCountLcv,
          totalCountScv: totalCountScv,
          totalCountIcv: totalCountIcv,
          totalCountPickup: totalCountPickup,
          totalCountRetread: totalCountRetread,
          totalWheelTruck: totalWheelTruck,
          totalWheelBus: totalWheelBus,
          totalWheelSCV: totalWheelSCV,
          totalWheelLCV: totalWheelLCV,
          totalWheelICV: totalWheelICV,
          totalWheelPickup: totalWheelPickup,
        });
        this.refs.refVehicleDetail.setData({
          totalCountBus: totalCountBus,
          totalCountTruck: totalCountTruck,
          totalCountLcv: totalCountLcv,
          totalCountScv: totalCountScv,
          totalCountIcv: totalCountIcv,
          totalCountPickup: totalCountPickup,
          totalCountRetread: totalCountRetread,
          totalWheelTruck: totalWheelTruck,
          totalWheelBus: totalWheelBus,
          totalWheelSCV: totalWheelSCV,
          totalWheelLCV: totalWheelLCV,
          totalWheelICV: totalWheelICV,
          totalWheelPickup: totalWheelPickup,
        });
      }

      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({
        isLoading: false
      })
      console.log(error);
    }
  }

  async getBusinessRelatedDetail() {
    let { business_related_detail_data } = this.state;
    try {
      const { data } = await FleetService.getBusinessRelatedDetails(null);
      if (data.data && Object.keys(data.data).length > 0) {
        business_related_detail_data = data.data;
      } else {
        business_related_detail_data = {};
      }
      if (this.refs.refVehicleDetail) {
        this.refs.refVehicleDetail.setFleetDetail(business_related_detail_data);
      }
      this.setState({
        business_related_detail_data
      })
    } catch (error) {
      console.log(error);
    }

  }

  updateTruckBusData = (params) => {
    const { controls } = this.state;
    const { truck, bus } = controls;
    truck.value = params.truck.value;
    bus.value = params.bus.value;
    this.setState({ controls });
  }

  openAddEditVehicle = (type, isAddVehicleDetail) => {
    let { isOpenAddEditVehicle } = this.state;
    this.setState({
      isOpenAddEditVehicle: !isOpenAddEditVehicle,
      addEditVehicleType: type,
      isAddVehicleDetail: isAddVehicleDetail
    });
  }

  closeSideBarAddEditVehicle = () => {
    let { isOpenAddEditVehicle } = this.state;
    this.setState({
      isOpenAddEditVehicle: !isOpenAddEditVehicle
    })
  }

  submitVehclies = (data) => {
    let { vehicleData } = this.state;
    if (Object.keys(data).length > 0) {
      vehicleData = data;
    } else {
      vehicleData = {};
    }
    this.setState({
      vehicleData: vehicleData,
      isOpenAddEditVehicle: false
    })
    this.getFleetData();
    this.getBusinessRelatedDetail();
    //this.scrollTo('VehicleDetail');
  }

  scrollTo(id) {
    var scroller = Scroll.scroller;
    scroller.scrollTo(id, {
      duration: 1000,
      delay: 100,
      smooth: "easeInOutQuint",
      offset: -80
    });
  }

  render() {
    const { controls, redirectToDashBoard, isListSubsidiaries } = this.state;
    const {
      email, phone, gst, pan, wa,
      primaryPerson, primaryNumber, primaryEmail, primaryDesignation, primaryWa,
      birthDate, website, instagram, facebook, anniversaryDate, sameAsUser,
    } = controls;
    const { location } = this.props;

    return <div>
      {redirectToDashBoard && <Redirect to="/dashboard" />}
      <div id="registration">
        {
          <Fragment>
            {this.state.isLoading && <CustomSpinner />}


            {
              this.stateAddEditSubsidiaries.addEditSubsidiaries && this.stateAddEditSubsidiaries.addEditSubsidiaries.length > 0 &&
              <Sidebar
                sidebar={<>
                  <div className="drawer-header">
                    <span className="drawer-title">{this.state.isAddSubsidiaries ? 'Add' : 'Edit'} Subsidiaries</span>
                    <img className="cursor-pointer" src="images/close.svg" alt='close' onClick={() => { this.onCloseSidebar(); }} />
                  </div>
                  <hr style={{ border: 'solid 1px #ced4da' }} />
                  <AddEditSubsidiaries
                    editSubsidiariesIndex={this.state.editSubsidiariesIndex}
                    addEditSubsidiaries={Object.assign([], this.stateAddEditSubsidiaries.addEditSubsidiaries)}
                    isAddSubsidiaries={this.state.isAddSubsidiaries}
                    addSubsidiaries={this.addSubsidiaries} ref="childAddEditSubsidiaries"
                    listSubsidiaries={[...this.stateAddEditSubsidiaries.addEditSubsidiaries]}
                    editSubsidiaries={this.editSubsidiaries}
                    removeSubsidiaries={this.removeSubsidiaries} />
                </>}
                open={this.state.sidebarOpen}
                sidebarClassName="subsdiaries-sidebar"
                pullRight
                styles={{ sidebar: { background: 'white', height: '100%' } }}
              />
            }
            {
              this.state.isOpenAddEditVehicle &&
              <Sidebar
                sidebar={
                  <AddEditFleetVehicle
                    addEditVehicleType={this.state.addEditVehicleType}
                    vehicleData={this.state.vehicleData}
                    vehicle_type={this.state.addEditVehicleType}
                    closeSideBar={this.closeSideBarAddEditVehicle}
                    submitVehclies={this.submitVehclies}
                    uuid={this.state.uuid}
                    isAddVehicleDetail={this.state.isAddVehicleDetail}
                    from="on-boarding" />
                }
                open={this.state.isOpenAddEditVehicle}
                sidebarClassName="subsdiaries-sidebar"
                pullRight
                styles={{ sidebar: { background: 'white', height: '100%', width: '40%' } }}
              />
            }


            <Fragment>

              <Row>
                <Col xl="1">
                  <img src={APP_HEADER_LOGO} height="64px" width="auto" alt="" />
                </Col>
                <Col xl="11" className="page-title text-align-center instruction">
                  Looks like some of your details are missing. Please fill them to enjoy the benefits!
                </Col>
              </Row>
              <br />
              <Row className="justify-content-center">
                <Col xl="1" style={{ display: 'none' }}>
                  <div className="side-column-container">
                    <span className="side-column-content" onClick={this.goToPreviousPage}>
                      <Ionicon icon="ios-arrow-back" fontSize="47px" color="#b5babe" width="32px" height="47px" className="cursor-pointer" />
                    </span>
                  </div>
                </Col>
                <Col xl="3" className="margin-top-10">
                  {/* <br /> */}
                  <ProfileDetail
                    sapId={this.state.sapId}
                    businessName={this.state.businessName}
                    ownerName={this.state.ownerName}
                    address={this.state.address}
                    profileImage={this.state.profileImage}
                    isImageUpdating={this.state.isImageUpdating}
                    handleUploadImage={this.handleUploadImage}
                    showRequestButton={false}
                  />
                  <br />
                  {
                    isListSubsidiaries && <ListSubsidiaries
                      listSubsidiaries={Object.assign([], this.stateAddEditSubsidiaries.addEditSubsidiaries)}
                      removeSubsidiaries={this.removeSubsidiaries}
                      addMoreSubsidiaries={this.onSetSidebarOpen}
                      editSubsidiaries={this.editSubsidiaries} />
                  }
                </Col>
                <Col xl="8" className="margin-top-10">
                  {/* <br /> */}
                  <Row
                    onClick={this.activeFragment.bind(this, 'business')}
                    id="form-business-detail"
                  >
                    <Col>
                      <EditOtherBusinessDetail
                        // className={activeFragment === 'business' ? 'card-yellow-border' : ''}
                        email={email}
                        phone={phone}
                        gst={gst}
                        pan={pan}
                        wa={wa}
                        controls={this.state.controls}
                        handleInputChange={this.handleInputChange}
                        ref={this.childFleetBusinessDetail}
                        activeFragment={this.activeFragment}
                      />
                    </Col>
                  </Row>
                  <br />
                  <Row
                    onClick={this.activeFragment.bind(this, 'contact')}
                  >
                    <Col>
                      <EditPrimaryContactDetail
                        // className={activeFragment === 'contact' ? 'card-yellow-border' : ''}
                        primaryPerson={primaryPerson}
                        primaryNumber={primaryNumber}
                        primaryDesignation={primaryDesignation}
                        primaryEmail={primaryEmail}
                        primaryWa={primaryWa}
                        sameAsUser={sameAsUser}
                        handleInputChange={this.handleInputChange}
                        activeFragment={this.activeFragment}
                        setSameAsUserCheckBoxValue={this.setSameAsUserCheckBoxValue}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4" id="form-communcation-detail">
                    <Col xl="12">
                      <NewFleetCommunicationDetail
                        ref={this.childNewFleetCommunicationDetail}
                        NewFleetBusinessDetail={Object.assign({}, {
                          current:
                            this
                        }
                        )}
                        from="registration"
                        refEditOtherBusinessDetail={this.childFleetBusinessDetail}
                        fleetByIdData={null} />
                    </Col>
                  </Row>
                  <Row id="form-personal-detail" className="mt-4">
                    <Col>
                      <NewFleetPersonalDetails
                        ref={this.childNewFleetPersonalDetails}
                        NewFleetBusinessDetail={this.childNewFleetBusinessDetail}
                        fleetByIdData={null} />
                    </Col>
                  </Row>

                  <br />
                  <Row
                    onClick={this.activeFragment.bind(this, 'social')}
                  >
                    <Col>
                      <EditSocialDetails
                        // className={activeFragment === 'social' ? 'card-yellow-border' : ''}
                        birthDate={birthDate}
                        anniversaryDate={anniversaryDate}
                        facebook={facebook}
                        instagram={instagram}
                        website={website}
                        handleInputChange={this.handleInputChange}
                        handleBirthDateChange={this.handleBirthDateChange}
                        handleAnniversaryDateChange={this.handleAnniversaryDateChange}
                        activeFragment={this.activeFragment}
                      />
                    </Col>
                  </Row>

                  {/* <Row
                      onClick={this.activeFragment.bind(this, 'fleet')}
                    >
                      <Col>
                        <EditFleetDetail
                          className={activeFragment === 'fleet' ? 'card-yellow-border' : ''}
                          truck={truck}
                          bus={bus}
                          scv={scv}
                          lcv={lcv}
                          // makeEditActiveFleet={null}
                          // makeEditActiveFleet={this.makeEditActiveFleet}
                          buildMyFleetClick={this.buildMyFleetClick}
                          handleInputChange={this.handleInputChange}
                          isFleeData={this.state.isFleeData}
                          activeFragment={this.activeFragment}
                        />
                      </Col>
                    </Row> */}
                  <Row id="form-vehicle-count-detail" style={{ padding: '15px' }}>
                    <VehicleCountDeatil
                      ref="refCountVehicleDetail"
                      uuid={null}
                      from="registration"
                      deleteFleetVehicle={this.deleteFleetVehicle}
                      openAddEditVehicle={(type, isAddVehicle) => this.openAddEditVehicle(type, isAddVehicle)} />
                  </Row>
                  {location && location.pathname !== "/on-boarding" ?
                    <Row id="form-vehcicle-detail" style={{ padding: '15px' }}>
                      <div id="VehicleDetail" className="w-100">
                        <VehicleDetail
                          fleetByIdData={null}
                          ref="refVehicleDetail"
                          vehicleData={this.state.vehicleData} />
                      </div>
                    </Row>
                    : ""}
                  <br />
                  <Row
                  // onClick={this.activeFragment.bind(this, 'social')}
                  >
                    {/* <Col xs="12" md="6" className="margin-top-5">
                      {
                        !isListSubsidiaries &&
                        <Button className="bottom-button" onClick={() => this.onSetSidebarOpen(true)}>
                          ADD SUBSIDIARIES
                        </Button>
                      }
                    </Col> */}
                    <Col xs="12" md="12" className="margin-top-5 text-align-right">
                      <Button
                        className="mb-1 mr-1 btn-pill action-button action-ob-button"
                        color="warning"
                        onClick={this.updateProfile}
                      // disabled={!isFormValid}
                      >
                        Save & Get Started
                      </Button>
                    </Col>
                  </Row>
                </Col>
                {/* <Col xl="1">
  
          </Col> */}

              </Row>
              <br />
              <Row>

                <Col xl="1" />
                <Col xl="11" className="text-align-right">
                  {/* <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="checkbox"
                  id="checkbox"
                  checked={agreeTermAndCondition}
                  onChange={this.setCheckBoxValue}
                />{' '}
                I have read and agreed to the Terms & Conditions
              </Label>
            </FormGroup>
            {' '} */}
                  {/* <Button
                      className="mb-1 mr-1 btn-pill action-button action-ob-button"
                      color="warning"
                      onClick={this.updateProfile}
                    // disabled={!isFormValid}
                    >
                      Save & Get Started
                    </Button> */}
                </Col>
                {/* <Col xl="1"></Col> */}
              </Row>

            </Fragment>
            <div className="logout" onClick={this.props.openLogoutModal}> <img src="images/logout.svg" alt="" /></div>
            <ConfirmModal ref="confirmModal" closeModal={this.closeConfirmSubsidiryAndFleet} />

          </Fragment>
        }
      </div>
    </div>
      ;
  }
}


const mapDispatchToProps = dispatch => ({
  setUserDetail: user => dispatch(setUserDetail(user)),
});


const mapStateToProp = state => ({
  userDetail: state.User.user,
});

export default withRouter(connect(mapStateToProp, mapDispatchToProps)(Registration));

// export default Registration;